import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FlexView from 'react-flexview/lib';

import * as actions from '../store/actions/churgerBuilderActions';

import ChatRoom from '../components/Halp/ChatRoom';

import '../index.css';

export default function Halp() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.setPage('notOrder'));
	});

	return (
		<FlexView
			column
			vAlignContent="center"
			hAlignContent="center"
			className="Halp"
		>
			{<ChatRoom />}
		</FlexView>
	);
}
